import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import BackToTop from "@/components/BackToTop";
import HeroSection from "@/components/HeroSection";
import HappeningTodaySection from "@/components/HappeningTodaySection";
import QuickLinksSection from "@/components/QuickLinksSection";
import SeoHead from "@/components/SeoHead";


// Below-the-fold sections — code-split to shrink initial JS
const TeaserGrid = lazy(() => import("@/components/TeaserGrid"));
const Footer = lazy(() => import("@/components/Footer"));
const MobileJumpButton = lazy(() => import("@/components/MobileJumpButton"));
const InstallPrompt = lazy(() => import("@/components/InstallPrompt"));

const SectionFallback = () => <div className="min-h-[40vh]" aria-hidden />;

const homeJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "San Diego Coastal Guide",
  url: "https://sandiegocoastalguide.com",
  description:
    "Your local guide to San Diego's beaches, surf, tides, dining, trails, and coastal adventures.",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://sandiegocoastalguide.com/?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

const Index = () => (
  <>
    <SeoHead
      title="San Diego Coast — Beaches, Tides, Surf & Coastal Guide"
      description="Your local guide to the San Diego coast: live tide charts, surf reports, every beach, coastal trails, dining, and events from Imperial Beach to Oceanside."
      path="/"
      jsonLd={homeJsonLd}
    />
    <Navbar />
    <main>
      <HeroSection />
      <HappeningTodaySection />
      <QuickLinksSection />
      <Suspense fallback={<SectionFallback />}>
        <TeaserGrid />
        <Footer />
        <MobileJumpButton />
        <InstallPrompt />
      </Suspense>
    </main>
    <BackToTop />
  </>
);

export default Index;
